import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/uma-general';

/**
 * GET UMAS Generales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getUmasGenerales = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET UMA General
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getUmaGeneral = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST UMA General
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postUmaGeneral = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH UMA General
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchUmaGeneral = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE UMA General
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteUmaGeneral = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
